import React, { forwardRef } from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}
export const Input = forwardRef<HTMLInputElement, InputProps>(({
  label,
  error,
  helperText,
  className = '',
  leftIcon,
  rightIcon,
  ...props
}, ref) => {
  return <div className="w-full" data-id="element-101">
        {label && <label className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-102">
            {label}
          </label>}
        <div className="relative" data-id="element-103">
          {leftIcon && <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400" data-id="element-104">
              {leftIcon}
            </div>}
          <input ref={ref} className={`
              block w-full h-10 rounded-lg border bg-white text-sm transition-colors
              placeholder:text-gray-400 
              focus:outline-none focus:ring-2 focus:ring-[#1B6B3A]/20 focus:border-[#1B6B3A]
              disabled:bg-gray-50 disabled:text-gray-400 disabled:cursor-not-allowed disabled:border-gray-200
              ${error ? 'border-red-300 focus:border-red-500 focus:ring-red-500/20 text-red-900 placeholder:text-red-300' : 'border-gray-300 text-gray-900'}
              ${leftIcon ? 'pl-10' : 'pl-3'}
              ${rightIcon ? 'pr-10' : 'pr-3'}
              ${className}
            `} {...props} data-id="element-105" />
          {rightIcon && <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none text-gray-400" data-id="element-106">
              {rightIcon}
            </div>}
        </div>
        {error && <p className="mt-1.5 text-sm text-red-600 flex items-center gap-1" data-id="element-107">
            {error}
          </p>}
        {helperText && !error && <p className="mt-1.5 text-sm text-gray-500" data-id="element-108">{helperText}</p>}
      </div>;
});
Input.displayName = 'Input';